import type { GetMemberInfoResponse } from './types';
import { defaultHttpClient } from '../httpClient';

/**
 * - 회원 정보 조회 API
 */
export const getMemberInfo = async () => {
  return defaultHttpClient
    .request<GetMemberInfoResponse>({
      method: 'GET',
      url: '/api/v2/members/me/',
    })
    .then(result => result.data);
};
